module.exports = __webpack_public_path__ + "static/media/calender.98c84523.svg";